import type { ComponentType } from "react";
import {
	type ClientPropertyArtDetailResponseDTO,
	type ClientPropertyCottageDetailResponseDTO,
	type ClientPropertyFlatDetailResponseDTO,
	type ClientPropertyHouseDetailResponseDTO,
	type ClientPropertyLandDetailResponseDTO,
	ClientPropertyTypeEnum,
	type ClientPropertyVehicleDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { ArtRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/Art/ArtRedesign";
import { AutoMotoRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/AutoMoto/AutoMotoRedesign";
import { CottageRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/Cottage/CottageRedesign";
import { FlatRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/Flat/FlatRedesign";
import { HouseRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/House/HouseRedesign";
import { LandRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/Land/LandRedesign";

export type PropertyDetail =
	| ClientPropertyVehicleDetailResponseDTO
	| ClientPropertyHouseDetailResponseDTO
	| ClientPropertyFlatDetailResponseDTO
	| ClientPropertyCottageDetailResponseDTO
	| ClientPropertyLandDetailResponseDTO
	| ClientPropertyArtDetailResponseDTO;

export type PropertySectionProps<T extends PropertyDetail> = {
	data: T;
	currencySign: string;
};

type SectionMap = {
	[ClientPropertyTypeEnum.AutoMoto]: ComponentType<
		PropertySectionProps<ClientPropertyVehicleDetailResponseDTO>
	>;
	[ClientPropertyTypeEnum.Art]: ComponentType<
		PropertySectionProps<ClientPropertyArtDetailResponseDTO>
	>;
	[ClientPropertyTypeEnum.Cottage]: ComponentType<
		PropertySectionProps<ClientPropertyCottageDetailResponseDTO>
	>;
	[ClientPropertyTypeEnum.Flat]: ComponentType<
		PropertySectionProps<ClientPropertyFlatDetailResponseDTO>
	>;
	[ClientPropertyTypeEnum.House]: ComponentType<
		PropertySectionProps<ClientPropertyHouseDetailResponseDTO>
	>;
	[ClientPropertyTypeEnum.Land]: ComponentType<
		PropertySectionProps<ClientPropertyLandDetailResponseDTO>
	>;
};

export const PROPERTY_SECTION_BY_TYPE: SectionMap = {
	[ClientPropertyTypeEnum.AutoMoto]: AutoMotoRedesign,
	[ClientPropertyTypeEnum.Art]: ArtRedesign,
	[ClientPropertyTypeEnum.Cottage]: CottageRedesign,
	[ClientPropertyTypeEnum.Flat]: FlatRedesign,
	[ClientPropertyTypeEnum.House]: HouseRedesign,
	[ClientPropertyTypeEnum.Land]: LandRedesign,
};

export const getPropertySection = <T extends PropertyDetail>(
	property: T,
): ComponentType<PropertySectionProps<T>> | undefined =>
	property.type in PROPERTY_SECTION_BY_TYPE
		? (PROPERTY_SECTION_BY_TYPE[
				property.type as keyof SectionMap
			] as ComponentType<PropertySectionProps<T>>)
		: undefined;
